@for (group of questionGroups; track group.groupType) {
    <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
        <div class="card-header fs-5 fw-medium">{{ group.groupType | checklistQuestionGroupType }}</div>
        <div class="card-body">
            <div class="d-flex flex-column gap-1 pe-md-5">
                @for (q of group.questions; track q.questionId) {
                    @if (q.questionId && answers[q.questionId]) {
                        <div class="question-row d-flex justify-content-between align-items-center gap-1">
                            <div>{{ q.title }}</div>
                            <dx-radio-group
                                class="flex-shrink-0"
                                layout="horizontal"
                                [items]="answerTypeOptions"
                                valueExpr="value"
                                displayExpr="text"
                                [(value)]="answers[q.questionId].answer"
                                [readOnly]="readOnly"
                            >
                                <dx-validator>
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-radio-group>
                        </div>
                    }
                }
            </div>
        </div>
    </div>
}
